<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>

<div class="card mt-4">
    <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbHome"></p-breadcrumb>
</div>

<div class="card mt-4">
    <p-fluid>   
        <form [formGroup]="doForm" (ngSubmit)="onSubmit()">
            <div class="flex flex-col md:flex-row gap-8">
                <div class="card flex flex-col gap-6 w-full">
                    <div class="font-semibold text-xl">Les informations pour - {{this.nomDo}} - {{this.do}} </div>
                    
                    <div class="flex flex-col md:flex-row gap-8">
                        <div class="flex flex-col gap-2 w-full">
                            <label for="code_interne">Code Interne</label>
                            <input pInputText id="code_interne" formControlName="code_interne" type="text" [disabled]="true" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Identifiant">Identifiant</label>
                            <input pInputText id="Identifiant" formControlName="Identifiant" type="text" [disabled]="true" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Nom">Nom</label>
                            <input pInputText id="Nom" formControlName="Nom" type="text" [disabled]="true" />
                        </div>
                    </div>

                    <div class="flex flex-col gap-2 w-full">
                        <label for="Activite">Activite</label>
                        <input pInputText id="Activite" formControlName="Activite" type="text" />
                    </div>

                    <div class="flex flex-col gap-4">
                        <div class="flex flex-wrap gap-6">
                            <div class="flex flex-col grow basis-0 gap-2">
                                <label for="MultiLangue">MultiLangue</label>
                                <input pInputText id="MultiLangue" formControlName="MultiLangue" type="text" />
                            </div>
                            <div class="flex flex-col grow basis-0 gap-2">
                                <label for="MissionPA">MissionPA</label>
                                <input pInputText id="MissionPA" formControlName="MissionPA" type="text" />
                            </div>
                        </div>
                    </div>

                    <p-divider class="w-full bg-surface-200"></p-divider>
                    
                    <!-- Site 1 -->
                    <div class="flex flex-col md:flex-row gap-12">
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site1Nom">Site1 Nom</label>
                            <input pInputText id="Site1Nom" formControlName="Site1Nom" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site1Adresse">Site1 Adresse</label>
                            <input pInputText id="Site1Adresse" formControlName="Site1Adresse" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site1Ville">Site1 Ville</label>
                            <input pInputText id="Site1Ville" formControlName="Site1Ville" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site1CP">Site1 CP</label>
                            <input pInputText id="Site1CP" formControlName="Site1CP" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site1Pays">Site1 Pays</label>
                            <input pInputText id="Site1Pays" formControlName="Site1Pays" type="text" />
                        </div>
                    </div>

                    <div class="flex flex-col md:flex-row gap-8">
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site1Telephone">Site1 Telephone</label>
                            <input pInputText id="Site1Telephone" formControlName="Site1Telephone" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site1Fax">Site1 Fax</label>
                            <input pInputText id="Site1Fax" formControlName="Site1Fax" type="text" />
                        </div>
                    </div>

                    <div class="flex flex-col gap-2 w-full">
                        <label for="Site1PlanAcces">Site1 PlanAcces</label>
                        <input pInputText id="Site1PlanAcces" formControlName="Site1PlanAcces" type="text" />
                    </div>

                    <p-divider class="w-full bg-surface-200"></p-divider>
                    
                    <!-- Site 2 -->
                    <div class="flex flex-col md:flex-row gap-12">
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site2Nom">Site2 Nom</label>
                            <input pInputText id="Site2Nom" formControlName="Site2Nom" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site2Adresse">Site2 Adresse</label>
                            <input pInputText id="Site2Adresse" formControlName="Site2Adresse" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site2Ville">Site2 Ville</label>
                            <input pInputText id="Site2Ville" formControlName="Site2Ville" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site2CP">Site2 CP</label>
                            <input pInputText id="Site2CP" formControlName="Site2CP" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site2Pays">Site2 Pays</label>
                            <input pInputText id="Site2Pays" formControlName="Site2Pays" type="text" />
                        </div>
                    </div>

                    <div class="flex flex-col gap-2 w-full">
                        <label for="Site2PlanAcces">Site2 PlanAcces</label>
                        <input pInputText id="Site2PlanAcces" formControlName="Site2PlanAcces" type="text" />
                    </div>

                    <p-divider class="w-full bg-surface-200"></p-divider>
                    
                    <!-- Site 3 -->
                    <div class="flex flex-col md:flex-row gap-12">
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site3Nom">Site3 Nom</label>
                            <input pInputText id="Site3Nom" formControlName="Site3Nom" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site3Adresse">Site3 Adresse</label>
                            <input pInputText id="Site3Adresse" formControlName="Site3Adresse" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site3Ville">Site3 Ville</label>
                            <input pInputText id="Site3Ville" formControlName="Site3Ville" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site3CP">Site3 CP</label>
                            <input pInputText id="Site3CP" formControlName="Site3CP" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site3Pays">Site3 Pays</label>
                            <input pInputText id="Site3Pays" formControlName="Site3Pays" type="text" />
                        </div>
                    </div>

                    <div class="flex flex-col md:flex-row gap-8">
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site3Telephone">Site3 Telephone</label>
                            <input pInputText id="Site3Telephone" formControlName="Site3Telephone" type="text" />
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="Site3Fax">Site3 Fax</label>
                            <input pInputText id="Site3Fax" formControlName="Site3Fax" type="text" />
                        </div>
                    </div>
                    
                    <div class="flex flex-col gap-2 w-full">
                        <label for="Site3PlanAcces">Site3 PlanAcces</label>
                        <input pInputText id="Site3PlanAcces" formControlName="Site3PlanAcces" type="text" />
                    </div>

                    <p-divider class="w-full bg-surface-200"></p-divider>

                    <div class="flex flex-col md:flex-row gap-8">
                        <div class="flex flex-col gap-2 w-full">
                            <label for="AdrEmailGenerale">Adresse Email</label>
                            <input pInputText id="AdrEmailGenerale" formControlName="AdrEmailGenerale" type="email" />
                            <p-message *ngIf="doForm.get('AdrEmailGenerale')?.invalid && doForm.get('AdrEmailGenerale')?.touched" severity="error" variant="simple" size="small" >
                                Entrez une adresse email valide
                            </p-message>
                        </div>
                        <div class="flex flex-col gap-2 w-full">
                            <label for="SiteWeb">Site Web</label>
                            <input pInputText id="SiteWeb" formControlName="SiteWeb" type="url" />
                        </div>
                    </div>
                </div> 
            </div>  

            <!-- button valider la sélection -->
            <div class="flex justify-end mt-3 gap-3">
                <p-button label="Annuler" styleClass="p-button-secondary" (click)="onCancel()"></p-button>
                <p-button label="Enregistrer" icon="pi pi-save" type="submit" [disabled]="doForm.invalid || !doForm.dirty" styleClass="p-button-primary"></p-button>
            </div>   
        </form>
    </p-fluid>
</div>